import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { IUser } from '../interfaces';
import { isPlatformServer } from '@angular/common';
import { ErrorsService } from '@app/errors/errors.service';

const USER_KEY = makeStateKey<IUser | null>('user-header');

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private _http: HttpClient,
    private _transferState: TransferState,
    private _errorsService: ErrorsService,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  getUser(): Observable<any> {
    const user: IUser | null = this._transferState.get<IUser | null>(USER_KEY, null);

    this._transferState.remove(USER_KEY);
    if (user) return of(user);

    return this._http.get(`${environment.apiUrl}/account/me/header_info/`).pipe(
      tap((user: any) => {
        if (isPlatformServer(this._platformId)) {
          this._transferState.set<IUser | null>(USER_KEY, user);
          console.log('User:', user, 'USER_KEY:', USER_KEY);
        }
      }),
      catchError((err) => {
        console.log(err);
        this._errorsService.openPopup(err);
        return [];
      }),
    );
  }
}
